module.exports = __webpack_public_path__ + "img/star-solid.a54b7386.svg";